import ACTION_TYPES from '../../constants/actionTypes';

const reducers = {

  isFetchingClaims(state = false, action) {
    switch (action.type) {
      case ACTION_TYPES.GET_CLAIMS_HISTORY:
        return true;
      case ACTION_TYPES.GET_CLAIMS_HISTORY_SUCCESS:
      case ACTION_TYPES.GET_CLAIMS_HISTORY_FAILURE:
        return false;
      default:
        return state;
    }
  },

  claimsHistoryFetchedAt(state = null, action) {
    switch (action.type) {
      case ACTION_TYPES.GET_CLAIMS_HISTORY_SUCCESS:
        return Date.now();
      case ACTION_TYPES.SUBMIT_CLAIM_SUCCESS:
      case ACTION_TYPES.SIGN_OUT:
        return null;
      default:
        return state;
    }
  },

  claims(state = [], action) {
    switch (action.type) {
      case ACTION_TYPES.GET_CLAIMS_HISTORY_SUCCESS:
        return action.claims;
      case ACTION_TYPES.SIGN_OUT:
        return [];
      default:
        return state;
    }
  },

  claimsProcessId(state = null, action) {
    switch (action.type) {
      case ACTION_TYPES.GET_CLAIMS_PROCESS_SUCCESS:
        return action.process.public_id;
      case ACTION_TYPES.SUBMIT_CLAIM_SUCCESS:
      case ACTION_TYPES.START_CLAIM:
      case ACTION_TYPES.SIGN_OUT:
        return null;
      default:
        return state;
    }
  },

  claimsProcessInstructions(state = {}, action) {
    switch (action.type) {
      case ACTION_TYPES.GET_CLAIMS_PROCESS_SUCCESS:
        return action.process.instructions;
      case ACTION_TYPES.GET_CLAIMS_PROCESS_FAILURE:
      case ACTION_TYPES.SUBMIT_CLAIM_SUCCESS:
      case ACTION_TYPES.START_CLAIM:
      case ACTION_TYPES.SIGN_OUT:
        return {};
      default:
        return state;
    }
  },

  claimsDeviceDamages(state = [], action) {
    switch (action.type) {
      case ACTION_TYPES.SAVE_CLAIMS_DEVICE_DAMAGES:
        return action.damages;
      case ACTION_TYPES.SUBMIT_CLAIM_SUCCESS:
      case ACTION_TYPES.START_CLAIM:
      case ACTION_TYPES.SIGN_OUT:
        return [];
      default:
        return state;
    }
  },

  claimsDeviceDamageDescription(state = null, action) {
    switch (action.type) {
      case ACTION_TYPES.SAVE_CLAIMS_DEVICE_DAMAGE_DESCRIPTION:
        return action.description;
      case ACTION_TYPES.SUBMIT_CLAIM_SUCCESS:
      case ACTION_TYPES.START_CLAIM:
      case ACTION_TYPES.SIGN_OUT:
        return null;
      default:
        return state;
    }
  },

  claimsDeviceSerialNumber(state = null, action) {
    switch (action.type) {
      case ACTION_TYPES.SAVE_CLAIMS_DEVICE_SERIAL_NUMBER:
        return action.serialNumber;
      case ACTION_TYPES.SUBMIT_CLAIM_SUCCESS:
      case ACTION_TYPES.START_CLAIM:
      case ACTION_TYPES.SIGN_OUT:
        return null;
      default:
        return state;
    }
  },

  isSavingBankAccount(state = false, action) {
    switch (action.type) {
      case ACTION_TYPES.SAVE_BANK_ACCOUNT:
        return true;
      case ACTION_TYPES.SAVE_BANK_ACCOUNT_SUCCESS:
      case ACTION_TYPES.SAVE_BANK_ACCOUNT_FAILURE:
        return false;
      default:
        return state;
    }
  },

  isSubmittingClaim(state = false, action) {
    switch (action.type) {
      case ACTION_TYPES.SUBMIT_CLAIM:
        return true;
      case ACTION_TYPES.SUBMIT_CLAIM_SUCCESS:
      case ACTION_TYPES.SUBMIT_CLAIM_FAILURE:
        return false;
      default:
        return state;
    }
  },

  isClaimsDeviceMailedOut(state = null, action) {
    switch (action.type) {
      case ACTION_TYPES.SAVE_CLAIMS_DEVICE_METHOD:
        return action.isDeviceMailedOut;
      case ACTION_TYPES.SUBMIT_CLAIM_SUCCESS:
      case ACTION_TYPES.START_CLAIM:
      case ACTION_TYPES.SIGN_OUT:
        return null;
      default:
        return state;
    }
  },

};

export default reducers;
